/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export enum ETransportNotificationUploadStatus {
  UNSENT = 'UNSENT',
  CONVERSION_ERROR = 'CONVERSION_ERROR',
  COMMUNICATION_ERROR = 'COMMUNICATION_ERROR',
  AUTHORIZATION_ERROR = 'AUTHORIZATION_ERROR',
  ERROR = 'ERROR',
  UPLOAD_SUCCESS = 'UPLOAD_SUCCESS',
  CANCEL_SUCCESS = 'CANCEL_SUCCESS',
}
